import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function SlideFade({ values = {} }: { values?: FieldValues }) {
  const [visible, setVisible] = useState(true)
  const initialX = values.initialX ?? -60
  const initialOpacity = values.initialOpacity ?? 0
  const stiffness = values.stiffness ?? 260
  const damping = values.damping ?? 20

  useEffect(() => {
    const interval = setInterval(() => setVisible((v) => !v), 2000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center h-full overflow-hidden">
      <AnimatePresence mode="wait">
        {visible && (
          <motion.div
            key="slide"
            initial={{ x: initialX, opacity: initialOpacity }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -initialX, opacity: initialOpacity }}
            transition={{ type: 'spring', stiffness, damping }}
            className="w-32 h-20 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl shadow-lg flex items-center justify-center"
          >
            <span className="text-white text-xs font-semibold">Page A</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
